import { ImageSizeSlider } from "portal/components/images/imageSizing/ImageSizeSlider";
import {
  MAX_THUMBNAIL_SIZE,
  MIN_THUMBNAIL_SIZE,
} from "portal/utils/categoryCollection/image";
import { Paper } from "@mui/material";
import { ShowLabelsToggle } from "portal/components/categoryCollectionProfile/ShowLabelsToggle";
import { updateCategoryCollectionThumbnailSize } from "portal/state/userPreferences";
import { useDispatch } from "react-redux";
import React, { FC } from "react";

interface ThumbnailControlsProps {
  measuredThumbnailMaxSize: number;
  thumbnailSize: number;
}

export const ThumbnailControls: FC<ThumbnailControlsProps> = ({
  measuredThumbnailMaxSize,
  thumbnailSize,
}) => {
  const dispatch = useDispatch();
  return (
    <Paper
      variant="section"
      className="flex gap-3 lg:gap-2 items-center px-2 rounded-md w-full md:w-auto justify-center flex-wrap"
    >
      <ImageSizeSlider
        className="w-36"
        min={MIN_THUMBNAIL_SIZE}
        max={Math.min(measuredThumbnailMaxSize, MAX_THUMBNAIL_SIZE)}
        value={thumbnailSize}
        onChange={(size) => {
          dispatch(updateCategoryCollectionThumbnailSize(size));
        }}
      />
      <ShowLabelsToggle />
    </Paper>
  );
};
